import React, { useState } from 'react'
import { Modal, Form, Input } from 'semantic-ui-react'
import { FlexRowBetween } from 'components'
import { X } from 'phosphor-react'
import { SubmitCancelButtons } from 'elements/Button'

const InvoiceEmailModal = ({ open, onClose, onSubmit, loading }) => {
    const [email, setEmail] = useState('')
    const [error, setError] = useState('')

    const validateEmail = value => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        return emailRegex.test(value)
    }

    const handleSave = () => {
        if (!email.trim()) {
            setError('Email ID is required')
            return
        }

        if (!validateEmail(email.trim())) {
            setError('Enter a valid email address')
            return
        }

        setError('')
        onSubmit(email.trim())
    }

    const handleClose = () => {
        setEmail('')
        setError('')
        onClose()
    }

    return (
        <Modal open={open} onClose={handleClose} size="tiny" className="model">
            <Modal.Header>
                <FlexRowBetween>
                    <span>Send Invoice Email</span>
                    <X className="pointer" size={32} onClick={handleClose} />
                </FlexRowBetween>
            </Modal.Header>

            <Modal.Content>
                <Form>
                    <Form.Field error={!!error}>
                        <label>Email ID:</label>
                        <Input
                            type="email"
                            placeholder="Enter email"
                            value={email}
                            onChange={(_, { value }) => setEmail(value)}
                            onKeyDown={e => {
                                if (e.key === 'Enter') {
                                    e.preventDefault()
                                    handleSave()
                                }
                            }}
                            autoFocus
                        />
                        {error && (
                            <div style={{ color: 'red', marginTop: 4 }}>
                                {error}
                            </div>
                        )}
                    </Form.Field>
                </Form>
            </Modal.Content>

            <Modal.Actions>
                <SubmitCancelButtons
                    loading={loading}
                    onSubmit={handleSave}
                    onCancel={handleClose}
                    hideCancel={false}
                    cancelText="Cancel"
                />
            </Modal.Actions>
        </Modal>
    )
}

export default InvoiceEmailModal
